/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CartItemEstimationVariables = Types.Exact<{
  item: Types.CartItemInput
}>

export type CartItemEstimation = {
  __typename: 'Query'
  cartItemEstimation: {
    __typename: 'CartItemPrice'
    taxIncluded: boolean
    total: { __typename: 'Money'; cents: number; formatted: string }
  }
}

export const CartItemEstimationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CartItemEstimation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'item' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CartItemInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cartItemEstimation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'item' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'item' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cents' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'formatted' }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'taxIncluded' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode

/**
 * __useCartItemEstimation__
 *
 * To run a query within a React component, call `useCartItemEstimation` and pass it any options that fit your needs.
 * When your component renders, `useCartItemEstimation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartItemEstimation({
 *   variables: {
 *      item: // value for 'item'
 *   },
 * });
 */
export function useCartItemEstimation(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    CartItemEstimation,
    CartItemEstimationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CartItemEstimation,
    CartItemEstimationVariables
  >(CartItemEstimationDocument, options)
}
export function useCartItemEstimationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CartItemEstimation,
    CartItemEstimationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CartItemEstimation,
    CartItemEstimationVariables
  >(CartItemEstimationDocument, options)
}
export type CartItemEstimationHookResult = ReturnType<
  typeof useCartItemEstimation
>
export type CartItemEstimationLazyQueryHookResult = ReturnType<
  typeof useCartItemEstimationLazyQuery
>
export type CartItemEstimationQueryResult = Apollo.QueryResult<
  CartItemEstimation,
  CartItemEstimationVariables
>
